import { render, staticRenderFns } from "./Pauses.vue?vue&type=template&id=0aa9d1be&scoped=true"
import script from "./Pauses.vue?vue&type=script&lang=js"
export * from "./Pauses.vue?vue&type=script&lang=js"
import style0 from "./Pauses.vue?vue&type=style&index=0&id=0aa9d1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9d1be",
  null
  
)

export default component.exports